import React, { useEffect } from 'react';
import { TbCalendarDollar } from 'react-icons/tb';
import { MdOutlineClose } from 'react-icons/md';
import TooltipComponent from 'components/Tooltip';
import { useEarningsData } from 'hooks/useEarningsQuery';
import { useEarnings } from 'hooks/useEarnings';
import { getEarningsTooltip } from 'utils/shared/earnings';
import { ModalHeaderProps } from './types';

const ModalHeader: React.FC<ModalHeaderProps> = ({ ticker, companyName, sector, onClose }) => {
  const { earningsMaps, fetchEarnings } = useEarnings();
  const { hasEarnings, getEarningsData, getDaysToEarnings } = useEarningsData(
    earningsMaps.earnings,
  );

  const tickerHasEarnings = ticker ? hasEarnings(ticker) : false;
  const earningsData = ticker ? getEarningsData(ticker) : null;
  const daysToEarnings = ticker ? getDaysToEarnings(ticker) : null;

  const iconColor = tickerHasEarnings ? 'text-graph-purple' : 'text-gray-400';

  useEffect(() => {
    if (ticker) {
      fetchEarnings();
    }
  }, [ticker, fetchEarnings]);

  const [imageError, setImageError] = React.useState(false);
  const sectorName = sector ? sector : 'N/A';

  return (
    <div className="flex flex-col border-b border-palette-border bg-palette-black-4 p-3">
      <div className="mb-2 flex w-full items-center justify-between">
        <div className="flex items-start gap-2">
          {!imageError ? (
            <img
              src={`https://images.financialmodelingprep.com/symbol/${ticker || ''}.png`}
              alt={`${ticker || ''} logo`}
              className="h-8 w-8 flex-shrink-0 rounded"
              onError={() => {
                setImageError(true);
              }}
            />
          ) : (
            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded bg-palette-black-5 text-xs font-bold text-white">
              {ticker || '?'}
            </div>
          )}
          <div className="flex flex-col gap-0.5">
            <div className="flex items-start gap-1 text-sm font-bold capitalize">
              <div>
                {companyName || 'OVERVIEW'}
                {sector && (
                  <div className="text-xs font-normal capitalize text-gray-400">{sectorName}</div>
                )}
              </div>
              <div
                className={`rounded-[4px] px-0.5 py-0.5 transition-all duration-300 sm:px-1 sm:py-1 ${iconColor} shadow-lg`}
              >
                <TooltipComponent
                  title={getEarningsTooltip(earningsData, daysToEarnings ?? null)}
                  position="bottom"
                >
                  <TbCalendarDollar aria-hidden="true" className="h-4 w-4" />
                </TooltipComponent>
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="flex-shrink-0 rounded p-1 text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
          aria-label="Close"
        >
          <MdOutlineClose className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default ModalHeader;
